// extracted by mini-css-extract-plugin
module.exports = {"Ticker":"Ticker_Ticker__PLMDZ","disableHover":"Ticker_disableHover__jA1yL"};